import { FC } from "react";
import NftImage from "../../images/NftImage";
import classNames from "classnames";
import { INft } from "logic/types/nft/INft";
import { BasicProps } from "components/types/BasicProps";

type Props = BasicProps & {
  nfts: INft[];
};

export const NftImages: FC<Props> = ({ nfts, className }) => {
  return (
    <>
      <div
        className={classNames(
          "w-full overflow-y-scroll overflow-x-hidden scrollbar-mynfts flex flex-wrap gap-4",
          className
        )}
      >
        {nfts.map((nft) => (
          <NftImage
            key={nft.alt}
            className="h-[138px] w-[138px] rounded-lg object-cover"
            src={nft.image}
            alt={nft.alt}
            depositedTag={nft.isDeposited}
            walletImage={nft.ownerType}
          />
        ))}
      </div>
    </>
  );
};
